import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Injectable()
export class SeoService {
  readonly #titleService = inject(Title);
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);

  appTitle = 'LAUTEC | Q';

  constructor() {
    // get default title from routing module
    this.#router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const routes = this.collectRoutes(this.#activatedRoute);

          const titledRoutes = routes.filter(r => !!r.snapshot.data?.['title']);

          if (!titledRoutes.length) {
            return null;
          }

          const drawerRoute = titledRoutes.find(r => r.outlet === 'drawer');

          const chosenRoute =
            drawerRoute ?? titledRoutes[titledRoutes.length - 1];
          return chosenRoute.snapshot.data['title'] as string;
        }),
        filter((title): title is string => !!title),
        distinctUntilChanged()
      )
      .subscribe(title => {
        this.updateTitle(title);
      });
  }

  updateTitle(...title: (string | number)[]): void {
    this.#titleService.setTitle(
      [...title.filter(x => !!x), this.appTitle].join(' - ')
    );
  }

  //#region Private methods

  private collectRoutes(route: ActivatedRoute): ActivatedRoute[] {
    // collect only the deepest child routes
    if (route.children.length === 0) {
      return [route];
    }

    return route.children.flatMap(child => this.collectRoutes(child));
  }

  //#endregion
}
